import { RECIRCULATION_SUCCESS, RECIRCULATION_FAILURE } from '../actions/types';

const defaultRecirculationState = () => ({
    items: [],
    error: false,
});

/* eslint-disable import/prefer-default-export */
export const fetchRecirculationReducer = (state = defaultRecirculationState(), action) => {
    if (action.type === RECIRCULATION_SUCCESS) {
        return {
            ...state,
            items: state.items.concat(action.payload),
        };
    }

    if (action.type === RECIRCULATION_FAILURE) {
        return {
            ...state,
            ...action.payload,
            error: true,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/recirculation.js
 **/